/**
 * session storage管理モジュール
 */
let storagePath = "";


/**
 * 初期化
 * @param path path
 */
function storageInit(path: string) {
  storagePath = path;
}


/**
 * 値を取得
 * @param key key
 * @returns value (失敗時はnull)
 */
function storageGetItem(key: string): string | null {
  let value = null;

  try {
    value = window.sessionStorage.getItem(
      storagePath + "." + key,
    );

  } catch (_e) {
    // nothing to do
  }

  return value;
}


/**
 * 値を設定
 * @param key key
 * @param value value
 */
function storageSetItem(key: string, value: string) {
  try {
    window.sessionStorage.setItem(
      storagePath + "." + key,
      value
    );

  } catch(_e) {
    // nothing to do
  }
}


/**
 * 値を削除
 * @param key key
 */
function storageRemoveItem(key: string) {
  try {
    window.sessionStorage.removeItem(
      storagePath + "." + key,
    );

  } catch(_e) {
    // nothing to do
  }
}


export {
  storageInit,
  storageGetItem,
  storageSetItem,
  storageRemoveItem,
};
